import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot"; // Import Chatbot
import routes from "./routes";
import ScrollToTop from "./pages/ScrollToTop";
import PrivateRoute from "./components/PrivateRoute";

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem("userId"));
  const navigate = useNavigate();

  // Session timeout in milliseconds (5 minutes = 5 * 60 * 1000 ms)
  const INACTIVITY_TIMEOUT = 5 * 60 * 1000;

  useEffect(() => {
    // Check for userId on mount
    const userId = localStorage.getItem("userId");
    if (userId) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
  }, []);

  const handleLogin = (userId) => {
    localStorage.setItem("userId", userId);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("userId");
    setIsAuthenticated(false);
    navigate("/login");
  };

  useEffect(() => {
    if (!isAuthenticated) return; // Don't start the timer if not authenticated

    let inactivityTimer;

    // Function to reset the timer on user activity
    const resetTimer = () => {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(() => {
        handleLogout();
      }, INACTIVITY_TIMEOUT);
    };

    // Function to handle user activity
    const handleActivity = () => {
      resetTimer();
    };

    // Add event listeners for user activity
    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("mousedown", handleActivity);
    window.addEventListener("keypress", handleActivity);
    window.addEventListener("scroll", handleActivity);

    // Start the timer initially
    resetTimer();

    // Cleanup event listeners and timer on unmount
    return () => {
      clearTimeout(inactivityTimer);
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("mousedown", handleActivity);
      window.removeEventListener("keypress", handleActivity);
      window.removeEventListener("scroll", handleActivity);
    };
  }, [isAuthenticated]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header isAuthenticated={isAuthenticated} onLogout={handleLogout} />
      <main className="flex-grow">
        <ScrollToTop />
        <Routes>
          {routes.map((route, index) => {
            if (route.protected) {
              return (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <PrivateRoute isAuthenticated={isAuthenticated}>
                      {route.element}
                    </PrivateRoute>
                  }
                />
              );
            }
            if (route.path === "/login") {
              return (
                <Route
                  key={index}
                  path={route.path}
                  element={React.cloneElement(route.element, { onLogin: handleLogin })}
                />
              );
            }
            return <Route key={index} path={route.path} element={route.element} />;
          })}
        </Routes>
      </main>
      <Footer />
      <Chatbot />
    </div>
  );
};
export default App;
